import React from "react";
import { Tooltip } from "@mui/material";

const WspolnotaRozliczenieZaleglosciTHead = (props) => {

  const { handleCheckAllSms, handleCheckAllEmail } = props;

  return (
    <thead>
      <tr>
        <th>
          Mieszkaniec
        </th>
        <th>
          Adres (grupa)
        </th>
        <th>
          Czynsze - suma
        </th>
        <th>
          Wpłaty - suma
        </th>
        <th>
          Saldo
        </th>
        <th>
          Ostatni czynsz /<br/> 2x ostatniego czynszu
        </th>
        {/* <th>
          Rodzaj
        </th> */}
        <th style={{whiteSpace: "nowrap"}}>
          <Tooltip
              title="Zaznacz / odznacz wszystkie"
              placement='top'
              onClick={handleCheckAllEmail}
              className="pointer u"
          >
            <span>e-mail</span>
          </Tooltip>
        </th>
        <th>
          <Tooltip
              title="Zaznacz / odznacz wszystkie"
              placement='top'
              onClick={handleCheckAllSms}
              className="pointer u"
          >
            <span>sms</span>
          </Tooltip>
        </th>
        <th style={{maxWidth: "500px"}}>
          Treść
        </th>
        <th>
          Ostatnie powiadomienie:<br/>data/kwota/kanał
        </th>
      </tr>
    </thead>
  )
}

export default WspolnotaRozliczenieZaleglosciTHead;